/**
 * @generated SignedSource<<497ecb1b18092a8ed89fc8ca76ab5933>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithSiblingCreate_fieldSets$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets";
};
export type row_nativeIssueTable_RowWithSiblingCreate_fieldSets$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithSiblingCreate_fieldSets$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithSiblingCreate_fieldSets">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets"
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};

(node as any).hash = "87ffe72235de098d0c77b063161d05e1";

export default node;
